import Validate from './validate';

export const MIN_SQUARE_METER_FOCUS_AREA = 35;
export const MIN_SQUARE_METER_DEFAULT = 40;

export default class SquareMeterValidation extends Validate {
  private minSquareMeter: number;

  private maxSquareMeter = 130;

  private checkMinSquareMeter: boolean;

  private checkMaxSquareMeter: boolean;

  constructor(checkMinSquareMeter = true, checkMaxSquareMeter = true, initialMinSquareMeter = MIN_SQUARE_METER_DEFAULT) {
    super();
    this.targets = document.getElementsByClassName('js-square-meter-validation') as HTMLCollectionOf<HTMLInputElement>;
    this.errorPositions = document.getElementsByClassName(
      'js-square-meter-error',
    ) as HTMLCollectionOf<HTMLInputElement>;
    this.checkMinSquareMeter = checkMinSquareMeter;
    this.checkMaxSquareMeter = checkMaxSquareMeter;
    this.minSquareMeter = initialMinSquareMeter;
  }

  setMinSquareMeter(value: number): void {
    this.minSquareMeter = value;
    this.recheck();
  }

  recheck(): void {
    for (let i = 0; i < this.targets.length; i++) {
      this.check(i);
    }
  }

  check(index: number): void {
    const target = this.targets[index];
    const { value } = target;

    if (!value) return;

    const squareMeter = Number(value);

    if (this.checkMinSquareMeter && squareMeter < this.minSquareMeter) {
      Validate.failed(target, this.errorPositions[index], `広さが${this.minSquareMeter}㎡未満はご利用いただけません`);
    } else if (this.checkMaxSquareMeter && squareMeter >= this.maxSquareMeter) {
      Validate.failed(target, this.errorPositions[index], `広さが${this.maxSquareMeter}㎡以上はご利用いただけません`);
    } else {
      Validate.resolved(target, this.errorPositions[index]);
    }
  }
}
